import * as Types from '../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BusinessUserProfileFragment = { __typename?: 'BusinessUser', accountId: number, organisationId: string, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, organisation?: { __typename?: 'Organisation', name: string } | null };

export type BusinessUserProfileQueryVariables = Types.Exact<{
  organisationId: Types.Scalars['String']['input'];
}>;


export type BusinessUserProfileQuery = { __typename?: 'Query', getOrganisationAccess?: { __typename?: 'OrganisationAccess', currentBusinessUser?: { __typename?: 'BusinessUser', accountId: number, organisationId: string, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, organisation?: { __typename?: 'Organisation', name: string } | null } | null } | null };

export type SaveBusinessUserProfileMutationVariables = Types.Exact<{
  accountId: Types.Scalars['Int']['input'];
  organisationId: Types.Scalars['String']['input'];
  firstName: Types.Scalars['String']['input'];
  lastName: Types.Scalars['String']['input'];
  phone: Types.Scalars['String']['input'];
}>;


export type SaveBusinessUserProfileMutation = { __typename?: 'Mutation', updateOwnBusinessUserProfile?: { __typename?: 'UpdateOwnBusinessUserProfilePayload', businessUser?: { __typename?: 'BusinessUser', accountId: number, organisationId: string, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, organisation?: { __typename?: 'Organisation', name: string } | null } | null } | null };

export const BusinessUserProfileFragmentDoc = gql`
    fragment BusinessUserProfile on BusinessUser {
  accountId
  organisationId
  firstName
  lastName
  phone
  email
  organisation {
    name
  }
}
    `;
export const BusinessUserProfileDocument = gql`
    query BusinessUserProfile($organisationId: String!) {
  getOrganisationAccess(organisationId: $organisationId) {
    currentBusinessUser {
      ...BusinessUserProfile
    }
  }
}
    ${BusinessUserProfileFragmentDoc}`;

/**
 * __useBusinessUserProfileQuery__
 *
 * To run a query within a React component, call `useBusinessUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessUserProfileQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useBusinessUserProfileQuery(baseOptions: Apollo.QueryHookOptions<BusinessUserProfileQuery, BusinessUserProfileQueryVariables> & ({ variables: BusinessUserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessUserProfileQuery, BusinessUserProfileQueryVariables>(BusinessUserProfileDocument, options);
      }
export function useBusinessUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessUserProfileQuery, BusinessUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessUserProfileQuery, BusinessUserProfileQueryVariables>(BusinessUserProfileDocument, options);
        }
export function useBusinessUserProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessUserProfileQuery, BusinessUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessUserProfileQuery, BusinessUserProfileQueryVariables>(BusinessUserProfileDocument, options);
        }
export type BusinessUserProfileQueryHookResult = ReturnType<typeof useBusinessUserProfileQuery>;
export type BusinessUserProfileLazyQueryHookResult = ReturnType<typeof useBusinessUserProfileLazyQuery>;
export type BusinessUserProfileSuspenseQueryHookResult = ReturnType<typeof useBusinessUserProfileSuspenseQuery>;
export type BusinessUserProfileQueryResult = Apollo.QueryResult<BusinessUserProfileQuery, BusinessUserProfileQueryVariables>;
export const SaveBusinessUserProfileDocument = gql`
    mutation SaveBusinessUserProfile($accountId: Int!, $organisationId: String!, $firstName: String!, $lastName: String!, $phone: String!) {
  updateOwnBusinessUserProfile(
    input: {accountId: $accountId, organisationId: $organisationId, firstName: $firstName, lastName: $lastName, phone: $phone}
  ) {
    businessUser {
      ...BusinessUserProfile
    }
  }
}
    ${BusinessUserProfileFragmentDoc}`;

/**
 * __useSaveBusinessUserProfileMutation__
 *
 * To run a mutation, you first call `useSaveBusinessUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBusinessUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBusinessUserProfileMutation, { data, loading, error }] = useSaveBusinessUserProfileMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      organisationId: // value for 'organisationId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useSaveBusinessUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveBusinessUserProfileMutation, SaveBusinessUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBusinessUserProfileMutation, SaveBusinessUserProfileMutationVariables>(SaveBusinessUserProfileDocument, options);
      }
export type SaveBusinessUserProfileMutationHookResult = ReturnType<typeof useSaveBusinessUserProfileMutation>;
export type SaveBusinessUserProfileMutationResult = Apollo.MutationResult<SaveBusinessUserProfileMutation>;
export type SaveBusinessUserProfileMutationOptions = Apollo.BaseMutationOptions<SaveBusinessUserProfileMutation, SaveBusinessUserProfileMutationVariables>;